var React = require('react');

function CameraIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_1901","data-name":"Ellipse 1901","cx":"7.5","cy":"7.5","r":"7.5","transform":"translate(19.792 19.792)","fill":"#2425aa","key":0}),React.createElement("path",{"id":"Path_53701","data-name":"Path 53701","d":"M20.015,4,15.828,8.622H8.576A4.6,4.6,0,0,0,4,13.243v27.73A4.6,4.6,0,0,0,8.576,45.6H45.181a4.6,4.6,0,0,0,4.576-4.622V13.243a4.6,4.6,0,0,0-4.576-4.622H37.929L33.742,4Zm6.863,34.663A11.555,11.555,0,1,1,38.317,27.109,11.5,11.5,0,0,1,26.878,38.663Z","transform":"translate(0.622 0.622)","fill":"#2425aa","key":1}),React.createElement("path",{"id":"Path_53702","data-name":"Path 53702","d":"M0,0H55V55H0Z","fill":"none","key":2})]);
}

CameraIcon.defaultProps = {"id":"Group_45230","data-name":"Group 45230","width":"55","height":"55","viewBox":"0 0 55 55"};

module.exports = CameraIcon;

CameraIcon.default = CameraIcon;
